/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { KeyData } from './tech.model';

export function parseJwkString(json: string): KeyData {
  return { key: json, keyId: extractKid(json) };
}

function extractKid(json: string): string {
  try {
    return JSON.parse(json).kid ?? '';
  } catch {
    return '';
  }
}

const VISIBLE_SUFFIX_LENGTH: number = 4;
const MAX_MASK_LENGTH: number = 6;

export function maskKeyId(kid: string): string {
  if (kid.length > VISIBLE_SUFFIX_LENGTH) {
    return buildMaskedKeyId(kid);
  }
  return kid;
}

function buildMaskedKeyId(kid: string): string {
  const maskLength: number = Math.min(kid.length - VISIBLE_SUFFIX_LENGTH, MAX_MASK_LENGTH);
  return '*'.repeat(maskLength) + kid.slice(-VISIBLE_SUFFIX_LENGTH);
}

export function getKeyCaption(fileContent: string): string | undefined {
  const keyData: KeyData = parseJwkString(fileContent);
  return keyData.keyId ? `Key-ID: ${maskKeyId(keyData.keyId)}` : undefined;
}
